import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { filter, Observable, of, take } from 'rxjs';
import { RulesService } from '../services/api/rules.service';
import { UrlParams } from '../models/enums/Route.enum';

@Injectable({
  providedIn: 'root'
})
export class RulesResolver implements Resolve<any> {
  constructor(
    private readonly rulesService: RulesService,
  ) { }

  /**
   * Questo resolver serve a bloccare la renderizzazione della pagina RulePage se non sono state
   * caricate le Rules.
   *
   * @param route
   * @param state
   * @returns
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {

    let ruleId = route.paramMap.get(UrlParams.Rule);
    //Controllo se le Rules sono state già caricate per evitare di ripetere l'invocazione dell'API
    if (this.rulesService.areRulesLoaded && ruleId) {
      this.rulesService.setSelectedRuleByUrlParam(ruleId);
      return of(true);
    }
    //In questo caso attendo che vengano caricate le Rules nel costruttore del Service
    // return this.rulesService.rules$.pipe(
    //   filter(rules => {
    //     return rules.length > 0;
    //   }),
    //   take(1),
    // )
    this.rulesService.loadRules();
    return this.rulesService.rules$.pipe(
      filter(rules => {
        return rules.length > 0;
      }),
      take(1),
    )
  }
}
